import dayjs from "dayjs";
import { uniqBy } from "lodash";
import React from "react";
import { useSelector } from "react-redux";
import { SetContentBy } from "./engagementHelpers";
import Messages from "./messages";

const MessagesGroup = ({
  date,
  dateMessages,
  userIdMap,
  handleOpportunityId,
  handleRetry,
  ...props
}) => {
  const { selectedLead } = useSelector(state => state.lead);
  return (
    <>
      <div className="flex-row-centered text-center items-center my-5 mx-0">
        <div className="flex-1 h-[1px] bg-grey-200" />
        <div className="px-5 text-xs font-[400] text-grey-600">
          {dayjs(date, "MM/DD/YYYY").format("MMM DD, YYYY")}
        </div>
        <div className="flex-1 h-[1px] bg-grey-200" />
      </div>
      <div className="flex-col-centered gap-4">
        {uniqBy(
          dateMessages.map(item => ({ ...item, id: +item.id })),
          "id"
        )
          .sort((a, b) => {
            const dateA = dayjs(a.dateReceived || a.dateSent);
            const dateB = dayjs(b.dateReceived || b.dateSent);

            // Sort in descending order, so the latest message is at the bottom
            return dateA.isBefore(dateB) ? -1 : 1;
          })
          .map((item, index) => {
            const messageProps = {
              ...props,
              userIdMap,
              handleRetry,
              selectedLead,
              SetContentBy,
              handleOpportunityId,
            };
            return <Messages key={index} c={item} messageIndex={index} {...messageProps} />;
          })}
      </div>
    </>
  );
};

export default MessagesGroup;
